import { render, staticRenderFns } from "./EnrollDetail.vue?vue&type=template&id=15455bbf&scoped=true&"
import script from "./EnrollDetail.vue?vue&type=script&lang=js&"
export * from "./EnrollDetail.vue?vue&type=script&lang=js&"
import style0 from "./EnrollDetail.vue?vue&type=style&index=0&id=15455bbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15455bbf",
  null
  
)

export default component.exports